import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './i18n/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'lang',
      checkWhitelist: true
    },
    resources: {
      es: {
        translation: es
      },
    },
    load: 'languageOnly',
    whitelist: ['es'],
    fallbackLng: 'es',
    debug: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    useSuspense: true,
  });
